import { db } from "./firebase"
import store from "./store"

export const easterEgg = (message: string) => {
  switch (message) {
    case "/hong user-agent":
      alert(window.navigator.userAgent)
      return true
    case "/kenny cookie":
      alert(window.document.cookie)
      return true
    case "/rigel histories":
      alert("created by rigel, 2018-2020")
      return true
    case "/etham hotkeys":
      alert(store.local.get(`hotkeys.F1`))
      return true
    case "/fb connect":
      db().goOnline()
      return true
    case "/fb disconnect":
      db().goOffline()
      return true
    default:
      return false
  }
}
